import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/arrow-left.svg'


const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "mb-8 max-w-[704px]" }
const _hoisted_3 = { class: "mt-8" }
const _hoisted_4 = {
  key: 0,
  class: "max-w-[704px] mt-5"
}
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = {
  key: 0,
  class: "max-w-[704px] mt-5"
}
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = { class: "flex w-[640px] mt-12 items-start content-start gap-4 flex-wrap" }
const _hoisted_10 = { class: "flex items-center space-x-2" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "!mt-10 mb-10 md:!mt-12 md:!mb-12" }

import { nextTick, onMounted, ref } from 'vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { getFormInput } from '@/utils/form-input-helper';
import FullScreenSpinner from '@/components/FullScreenSpinner/FullScreenSpinner.vue';
import { ToastAlertType } from '@/enums/toast-alert-enum';
import { useToastAlertStore } from '@/store/toast-alert/toast-alert.state';
import { useAccountStore, useAnalyticsStore } from '@/store';
import InformationBox from '@/components/InformationBox/InformationBox.vue';
import PanelTitle from '@/components/PanelTitle/PanelTitle.vue';
import {
  CommunicationPreferences,
  CommunicationPreferenceOptions,
  getEnumValue,
} from '@/interfaces/self-service/communication-preferences';
import { SelfServiceService } from '@/services/store';
import Divider from '@/components/Divider/Divider.vue';
import { PageAnalyticsBuilder } from '@/utils/page-analytics-builder';
import { useI18n } from 'vue-i18n';
import { FormEvents } from '@/enums/form-events.enum';
import { Link } from '@sitecore-jss/sitecore-jss-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CommunicationOptionsPage',
  props: {
    content: {},
    id: {},
    name: {}
  },
  setup(__props: any) {

const accountStore = useAccountStore();
const toastAlertStore = useToastAlertStore();
const analyticsStore = useAnalyticsStore();

const props = __props;

const communicationPreferenceOptions = [
  { label: 'Postal mail', value: CommunicationPreferenceOptions[CommunicationPreferenceOptions.PostalPhysical] },
  { label: 'Email or SMS', value: CommunicationPreferenceOptions[CommunicationPreferenceOptions.DigitalEmail] },
];

const showSavingOrLoading = ref<boolean>(false);
const switchToDigitalUpdatesMessage = ref(getFormInput(props.content, 'switchToDigitalUpdatesMessage'));
const transactionalOptionsLabel = ref(getFormInput(props.content, 'transactionalOptionsLabel'));
const agmOptionsLabel = ref(getFormInput(props.content, 'agmOptionsLabel'));
const transactionalOptionInvalidMessage = ref(getFormInput(props.content, 'transactionalOptionInvalidMessage'));
const agmOptionInvalidMessage = ref(getFormInput(props.content, 'agmOptionInvalidMessage'));
const discardChangesLink = ref(getFormInput(props.content, 'discardChangesLink'));

const subscriptions = <any>[];
const hasChanges = ref<boolean>(false);

const model = ref<any>({
  deliveryChannelNotices: '',
  deliveryChannelAgm: '',
  deliveryChannelNoticesInvalid: false,
  deliveryChannelAgmInvalid: false,
});

const dictionary = useI18n().getLocaleMessage('en') as Record<string, string>;

onMounted(async () => {
  await loadPreferences();
  pushAnalytics();
});

const loadPreferences = async () => {
  showSavingOrLoading.value = true;
  try {
    const d365Id = accountStore.identityDetails?.d365Id ?? '';
    if (d365Id) {
      subscriptions.values = await SelfServiceService.getSubscriptions(d365Id);

      model.value.deliveryChannelNotices = getSelectedValueByValue(subscriptions.values.deliveryChannelNotices);
      model.value.deliveryChannelAgm = getSelectedValueByValue(subscriptions.values.deliveryChannelAgm);

      model.value.deliveryChannelNoticesInvalid = !model.value.deliveryChannelNotices;
      model.value.deliveryChannelAgmInvalid = !model.value.deliveryChannelAgm;
    }
  } catch (error) {
    console.error(error);
  }

  await nextTick();
  showSavingOrLoading.value = false;
};

const onOptionChange = (e: any) => {
  if (showSavingOrLoading.value) return;
  hasChanges.value = true;
};

const getOptionsForInput = () => {
  return communicationPreferenceOptions.map((opt) => {
    return opt.label;
  });
};

const getSelectedValueByValue = (value: string) => {
  const enumValue = getEnumValue(value);
  if (enumValue !== undefined) {
    const selected = communicationPreferenceOptions.find((x) => x.value === CommunicationPreferenceOptions[enumValue]);
    return selected?.label;
  }
  return '';
};

const getSelectedValueByDisplayValue = (selectedOption: string) => {
  const selected = communicationPreferenceOptions.find((x) => x.label.toLowerCase() === selectedOption?.toLowerCase());
  return selected?.value;
};

const isInvalid = (submitModel: CommunicationPreferences) => {
  model.value.deliveryChannelNoticesInvalid = !submitModel.deliveryChannelNotices;
  model.value.deliveryChannelAgmInvalid = !submitModel.deliveryChannelAgm;
  return model.value.deliveryChannelNoticesInvalid || model.value.deliveryChannelAgmInvalid;
};

const onSave = async () => {
  try {
    const submitModel = {
      deliveryChannelNotices: getSelectedValueByDisplayValue(model.value.deliveryChannelNotices),
      deliveryChannelAgm: getSelectedValueByDisplayValue(model.value.deliveryChannelAgm),
    } as CommunicationPreferences;

    if (isInvalid(submitModel)) {
      return;
    }

    showSavingOrLoading.value = true;

    const d365Id = accountStore.identityDetails?.d365Id ?? '';

    if (d365Id) {
      const response = await SelfServiceService.communicationsPreferences(d365Id, submitModel);

      if (response) {
        hasChanges.value = false;

        toastAlertStore.addToastAlert({
          title: 'Communication preferences updated',
          description: '',
          type: ToastAlertType.SUCCESS,
          duration: 6000,
        });

        showSavingOrLoading.value = false;

        await analyticsStore.pushAnalytics({
          event: FormEvents.COMPLETE,
          form: {
            name: 'Communication preferences',
            stepName: 'FormCompleted',
          },
          profileInfo: {
            agmCommPref: model.value.deliveryChannelAgm,
            transCommPref: model.value.deliveryChannelNotices,
          },
        });

        return;
      }
    }
  } catch (error) {
    showSavingOrLoading.value = false;
    toastAlertStore.addToastAlert({
      title: 'Unable to save changes',
      description: '',
      type: ToastAlertType.ERROR,
      duration: 6000,
    });

    await analyticsStore.pushAnalytics({
      event: FormEvents.JEOPARDY,
      form: {
        name: 'Communication preferences',
        formErrorType: 'Unable to save changes',
        formErrorDetail: 'Unable to save changes',
      },
    });
  }
};

const pushAnalytics = () => {
  const pageAnalytics = new PageAnalyticsBuilder();
  pageAnalytics.populateProducts(dictionary);

  pageAnalytics.pageAnalytics.profileInfo!.agmCommPref = model.value.deliveryChannelAgm;
  pageAnalytics.pageAnalytics.profileInfo!.transCommPref = model.value.deliveryChannelNotices;

  pageAnalytics.pushAnalytics();
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_component_FormKit, {
    name: "comPreferences",
    type: "form",
    onSubmit: onSave
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormStepInputs, {
          step: {
          stepName: _ctx.name,
          formInputs: _ctx.content,
        }
        }, {
          switchToDigitalUpdatesMessage: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(InformationBox, {
                title: switchToDigitalUpdatesMessage.value.title.value,
                class: "flex items-start gap-4 p-5 px-6 self-stretch",
                description: switchToDigitalUpdatesMessage.value.content.value,
                type: switchToDigitalUpdatesMessage.value.messageType.value,
                isCircle: true,
                useButtonSlot: false
              }, null, 8, ["title", "description", "type"])
            ])
          ]),
          transactionalCommsTitle: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(PanelTitle, _normalizeProps(_guardReactiveProps(_unref(getFormInput)(props.content, 'transactionalCommsTitle'))), null, 16)
            ])
          ]),
          transactionalOptionInvalidMessage: _withCtx(() => [
            (model.value.deliveryChannelNoticesInvalid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(InformationBox, {
                    title: transactionalOptionInvalidMessage.value.title.value,
                    class: "flex items-start gap-4 p-5 px-6 self-stretch",
                    description: transactionalOptionInvalidMessage.value.content.value,
                    type: transactionalOptionInvalidMessage.value.messageType.value,
                    isCircle: true,
                    useButtonSlot: false,
                    hideIcon: true
                  }, null, 8, ["title", "description", "type"])
                ]))
              : _createCommentVNode("", true)
          ]),
          transactionalOptionsLabel: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_FormKit, {
                modelValue: model.value.deliveryChannelNotices,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.deliveryChannelNotices) = $event)),
                label: transactionalOptionsLabel.value?.label?.value,
                innerClass: 'text-base',
                inputClass: "text-lg",
                type: "nativeRadio",
                name: "deliveryChannelNotices",
                outerClass: "-mt-1",
                options: getOptionsForInput(),
                onInput: _cache[1] || (_cache[1] = (e) => onOptionChange(e))
              }, null, 8, ["modelValue", "label", "options"])
            ])
          ]),
          agmNoticesCommsTitle: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(PanelTitle, _normalizeProps(_guardReactiveProps(_unref(getFormInput)(props.content, 'agmNoticesCommsTitle'))), null, 16)
            ])
          ]),
          agmOptionInvalidMessage: _withCtx(() => [
            (model.value.deliveryChannelAgmInvalid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(InformationBox, {
                    title: agmOptionInvalidMessage.value.title.value,
                    class: "flex items-start gap-4 p-5 px-6 self-stretch",
                    description: agmOptionInvalidMessage.value.content.value,
                    type: agmOptionInvalidMessage.value.messageType.value,
                    isCircle: true,
                    useButtonSlot: false,
                    hideIcon: true
                  }, null, 8, ["title", "description", "type"])
                ]))
              : _createCommentVNode("", true)
          ]),
          agmOptionsLabel: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_FormKit, {
                modelValue: model.value.deliveryChannelAgm,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.value.deliveryChannelAgm) = $event)),
                label: agmOptionsLabel.value?.label?.value,
                innerClass: 'text-base',
                inputClass: "text-lg",
                type: "nativeRadio",
                name: "deliveryChannelAGM",
                outerClass: "-mt-1",
                options: getOptionsForInput(),
                onInput: _cache[3] || (_cache[3] = (e) => onOptionChange(e))
              }, null, 8, ["modelValue", "label", "options"])
            ])
          ]),
          _: 1
        }, 8, ["step"]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(Link), {
            field: discardChangesLink.value?.link,
            class: "btn btn-tertiary btn-md"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _cache[4] || (_cache[4] = _createElementVNode("img", {
                  src: _imports_0,
                  alt: "left arrow",
                  class: "w-5 h-5 inline-block"
                }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(discardChangesLink.value?.link?.value?.text), 1)
              ])
            ]),
            _: 1
          }, 8, ["field"]),
          _createElementVNode("button", {
            type: "submit",
            disabled: !hasChanges.value,
            class: "btn btn-md btn-primary"
          }, "Save changes", 8, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(Divider)
        ]),
        (showSavingOrLoading.value)
          ? (_openBlock(), _createBlock(FullScreenSpinner, {
              key: 0,
              applyOpacity: true
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})